import {
  SET_COMPANY_NAME,
  SET_COMPANY_TOKEN,
  SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED,
} from '../actions/action_company';

const INITIAL_STATE = {
  name: '', // This is actually the CSS class name, kept for backward compatibility
  token: '', // This is the actual company identifier (auth_token value)
  nonUsInternationalizationEnabled: false,
};

export default function (state = INITIAL_STATE, action) {
  Object.freeze(state);

  switch (action.type) {
    case SET_COMPANY_NAME:
      // Sets the CSS class name (from data.css)
      return { ...state, name: action.payload };
    case SET_COMPANY_TOKEN:
      // Sets the company identifier (from data.token)
      return { ...state, token: action.payload };
    case SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED:
      return { ...state, nonUsInternationalizationEnabled: action.payload };
    default:
      return state;
  }
}
